export default __webpack_public_path__ + "static/media/d.962a3524.wav";